import { LOGIN, USER_INFO, LOGOUT, USER_TOKEN_REFRESH } from '../actions/types';
import normalize from 'json-api-normalizer';
import userInfo from '../actions/userInfo';
import config from 'config';
import { get } from 'global/lib/lodash';

const qs = require('qs');

const isAxiosRequest = (action) => action.payload && action.payload.request;

function makeStoreMetaUrl(action) {
  const metaKey = get(action, 'meta.metaKey', false);
  const metaPostKey = get(action, 'meta.metaPostKey', false);

  if (metaKey && metaPostKey) {
    return [metaKey, metaPostKey].join('?');
  } else if (metaKey) {
    return metaKey + '?root';
  } else {
    return action.payload.request.url;
  }
}

function refreshAccessToken(client, store, originalAction) {
  const refreshData = {
    grant_type: 'refresh_token',
    client_id: config.api.clientId,
    client_secret: config.api.clientSecret,
    refresh_token: store.getState().auth.refreshToken,
  };

  const refreshBody = qs.stringify(refreshData);

  const action = {
    type: USER_TOKEN_REFRESH,
    payload: {
      request: {
        baseURL: config.api.baseUrl,
        url: 'oauth/token/refresh',
        method: 'post',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json',
        },
        data: refreshBody,
      },
    },
  };

  client
    .request(action.payload.request)
    .then((response) => {
      const successActionType = action.type + '_SUCCESS';

      store.dispatch({
        type: successActionType,
        payload: normalize(response.data, { endpoint: action.payload.request.url, filterEndpoint: false }),
        meta: {
          previousAction: action,
        },
      });

      store.dispatch(originalAction);
    })
    .catch((error) => {
      console.error(error);
      const failedActionType = action.type + '_FAILED';
      store.dispatch({
        type: failedActionType,
        payload: {
          error: error,
        },
        meta: {
          previousAction: action,
        },
      });
      throw error;
    });
}

const axiosMiddleware = (client) => (store) => (next) => (action) => {
  const accessToken = store.getState().auth.accessToken;
  const accessTokenValidUntil = store.getState().auth.accessTokenValidUntil;
  const accessTokenSetAt = store.getState().auth.accessTokenSetAt;
  const currentTimestamp = Math.floor(Date.now() / 1000);

  if (false && accessToken && currentTimestamp - accessTokenSetAt > accessTokenValidUntil) {
    refreshAccessToken(client, store, action);
    return;
  }

  const request = isAxiosRequest(action)
    ? () => {
        const startedActionType = action.type + '_STARTED';
        store.dispatch({
          type: startedActionType,
          meta: {
            loading: true,
            previousAction: action,
          },
        });
        return client
          .request(action.payload.request)
          .then((response) => {
            const successActionType = action.type + '_SUCCESS';
            const loadTime = Date.now();
            switch (action.type) {
              case LOGIN:
                store.dispatch({
                  type: successActionType,
                  payload: response.data,
                  meta: {
                    loadedAt: loadTime,
                    previousAction: action,
                  },
                });

                store.dispatch(userInfo());

                break;
              case LOGOUT:
              case USER_INFO:
              case USER_TOKEN_REFRESH:
                store.dispatch({
                  type: successActionType,
                  payload: response.data,
                  meta: {
                    loadedAt: loadTime,
                    previousAction: action,
                  },
                });
                break;
              default:
                const storeMetaUrl = makeStoreMetaUrl(action);
                const shouldFilter = storeMetaUrl.indexOf('?') === -1;
                store.dispatch({
                  type: successActionType,
                  payload: normalize(response.data, { endpoint: storeMetaUrl, filterEndpoint: shouldFilter }),
                  meta: {
                    loadedAt: loadTime,
                    previousAction: action,
                    responseMeta: response.data.meta,
                  },
                });
                break;
            }
          })
          .catch((error) => {
            console.error(error);
            const failedActionType = action.type + '_FAILED';
            store.dispatch({
              type: failedActionType,
              payload: {
                error: error,
              },
              meta: {
                error,
                loadedAt: Date.now(),
                previousAction: action,
              },
            });
            throw error;
          });
      }
    : action;

  return next(request);
};

export default axiosMiddleware;
